import { defineComponent as _defineComponent } from 'vue'
import { storeToRefs } from 'pinia';
import IconButton from '../common/base/IconButton.vue';
import StageApplicationIcon from '../common/icons/StageApplicationIcon.vue';
import { useBasicStore } from '../../stores/basic';
import { useRoomStore } from '../../stores/room';
import { useI18n } from '../../locales';
import TuiBadge from '../common/base/Badge.vue';
import { isMobile } from '../../utils/environment';
import MasterApplyControl from './ApplyControl/MasterApplyControl';
import useMasterApplyControl from '../../hooks/useMasterApplyControl';


export default /*#__PURE__*/_defineComponent({
  __name: 'ManageStageControl',
  setup(__props) {

const { t } = useI18n();

const basicStore = useBasicStore();
const roomStore = useRoomStore();
const { handleShowNotification } = useMasterApplyControl();
const { sidebarName, showApplyUserList } = storeToRefs(basicStore);
const { applyToAnchorList } = storeToRefs(roomStore);

function toggleManageStage() {
  if (!isMobile) {
    basicStore.setShowApplyUserList(!showApplyUserList.value);
  } else {
    if (basicStore.isSidebarOpen && basicStore.sidebarName === 'apply') {
      basicStore.setSidebarOpenStatus(false);
      basicStore.setSidebarName('');
      return;
    }
    basicStore.setSidebarOpenStatus(true);
    basicStore.setSidebarName('apply');
  }
}

handleShowNotification();

return { __sfc: true,t, basicStore, roomStore, handleShowNotification, sidebarName, showApplyUserList, applyToAnchorList, toggleManageStage, IconButton, StageApplicationIcon, TuiBadge, MasterApplyControl }
}

})